export default [
    {name: "Efectivo", id: 1},
    {name: "Consignación/transferencia", id: 2},
    {name: "Cheque", id: 3}
]